import React from "react";

export const Marquee = ({ text, className = "" }) => {
  const repeated = `${text} ${text} ${text} ${text} `;
  return (
    <div
      className={`w-full overflow-hidden bg-trise-blue py-7 border-y border-trise-brass/30 ${className}`}
      data-testid="editorial-marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        <span className="text-2xl md:text-3xl font-bold uppercase tracking-widen text-trise-brass">
          {repeated}
        </span>
        <span className="text-2xl md:text-3xl font-bold uppercase tracking-widen text-trise-brass" aria-hidden="true">
          {repeated}
        </span>
      </div>
    </div>
  );
};
